import '.ac{background-color:var(--palette-blue-50);}.ssr-plugin'
import '.ad{padding:1rem;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.ae{justify-content:center;}.ssr-plugin'
import '.af{width:6.1875rem;}.ssr-plugin'
import '.ag{border-radius:9px;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import Column from '@app/components/layout/Column'
import { Card } from '../card/Card'

export interface EventProps {
  date: number
  month: string
  category: string
  title: string
  intro?: string
  time: string
  location: string
  onClick?: () => void
  to?: string
  style?: Style
}

export const Event = ({
  date,
  month,
  category,
  title,
  intro,
  time,
  location,
  onClick,
  to,
  style,
}: EventProps) => {
  return (
    <Card
      orientation="horizontal"
      onClick={onClick}
      style={style}
      to={to ?? undefined}
      padded
      imageStyle={{
        minWidth: '6.1875rem',
        width: 'auto',
        borderRadius: '9px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      image={
        <div className="ac ad a b r ae af ag"
          data-testid="event-date-section"
        >
          <Text.Large
            style={{
              fontSize: '3.6rem',
              fontWeight: '700',
              color: 'var(--palette-blue-500)',
              lineHeight: '1',
              margin: 0,
            }}
            color="var(--palette-blue-500)"
          >
            {date}
          </Text.Large>
          <Text.ExtraSmall color="var(--palette-blue-500)">
            {String(month).toUpperCase()}
          </Text.ExtraSmall>
        </div>
      }
      contentStyle={{
        paddingLeft: '0',
      }}
    >
      {/* Event Details Section */}
      <Column
        style={{
          height: '100%',
          flex: 1,
          alignItems: 'flex-start',
          justifyContent: 'space-between',
        }}
        gap="0.5rem"
      >
        <div className="s">
          {/* Category */}
          <Text.ExtraSmall
            isBold={true}
            style={{ marginBottom: '0.5rem' }}
            color="var(--brand-primary)"
          >
            {category.toUpperCase()}
          </Text.ExtraSmall>

          {/* Title */}
          <Text.Medium
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              marginBottom: '0.5rem',
            }}
            color="var(--brand-secondary)"
          >
            {title}
          </Text.Medium>

          {/* Intro */}
          {intro && (
            <Text.Small
              style={{
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}
              color="var(--palette-blue-600)"
            >
              {intro}
            </Text.Small>
          )}
        </div>
        {/* Time and Location - aligned to bottom */}
        <styled.div>
          <Text.ExtraSmall
            style={{
              WebkitLineClamp: 1,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
            }}
            color="var(--brand-secondary)"
          >
            {time} · {location}
          </Text.ExtraSmall>
        </styled.div>
      </Column>
    </Card>
  )
}
